import { render, staticRenderFns } from "./TableRatesCell.vue?vue&type=template&id=71da0205&scoped=true&functional=true&"
import script from "./TableRatesCell.vue?vue&type=script&lang=js&"
export * from "./TableRatesCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "71da0205",
  null
  
)

export default component.exports